import { removeIdToken } from "../http/id-token";
import RemergeApi from "../http/RemergeApi";
import { redirectToLogin } from "./redirects";
import { clearSsoAuthType } from "./sso-state";

export type PerformSharedLogoutParams = {
  remergeApi: RemergeApi;
  isAuth0Authenticated: boolean;
  auth0Logout: (opts?: { logoutParams?: { returnTo?: string } }) => void;
  loginBaseUrl: string;
  beforeAuth0Logout?: () => void;
  afterClientCleanup?: () => void;
};

/**
 * Executes shared logout sequence for hybrid legacy/Auth0 flows.
 *
 * Security invariant: local auth artifacts are cleared before any redirect,
 * regardless of backend sign-out outcome.
 */
export async function performSharedLogout({
  remergeApi,
  isAuth0Authenticated,
  auth0Logout,
  loginBaseUrl,
  beforeAuth0Logout,
  afterClientCleanup,
}: PerformSharedLogoutParams): Promise<void> {
  try {
    await remergeApi.sessionsDelete();
  } catch {
    // Best-effort backend sign-out.
  }

  // Local client-state cleanup always runs before any redirect/logout hop.
  clearSsoAuthType();
  removeIdToken();
  afterClientCleanup?.();

  if (isAuth0Authenticated) {
    // Auth0 logout is the remote identity-provider transition.
    beforeAuth0Logout?.();
    auth0Logout({ logoutParams: { returnTo: window.location.origin } });
    return;
  }

  redirectToLogin({ loginBaseUrl });
}
